export default __webpack_public_path__ + "static/media/invite-member.5d1c0b22.svg";